
import { Routes, Route } from 'react-router-dom';
import PrivateRoute from './components/Routes/PrivateRoute';
import IsHrRoute from './components/Routes/IsHrRoute';
import AdminRoute from './components/Routes/AdminRoute';
import Home from './pages/Home';
import Strategi from './pages/Strategi';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import Månedsrapport from './pages/Månedsrapport';
import Rollefordeling from './pages/Rollefordeling';
import AdminPanel from './pages/AdminPanel';
import ForgotPassword from './pages/ForgotPassword';
import Profile from './pages/Profile';
import PublicRoute from './components/Routes/PublicRoute';
import AccessDeniedPage from './pages/ValuatorPages/AccessDeniedPage';
import ValuatorAdminPanel from './pages/ValuatorPages/ValuatorAdminPanel';
import CaseListPage from './pages/ValuatorPages/CaseListPage';
import ValuatorHome from './pages/ValuatorPages/ValuatorHome';
import ArchivedCaseListPage from './pages/ValuatorPages/ArchivedCaseListPage';
import CasePage from './pages/ValuatorPages/CasePage';
import WorkersPage from './pages/ValuatorPages/WorkersPage';
import WorkerDetailsPage from './pages/ValuatorPages/WorkerDetailsPage';
import ValuatePage from './pages/ValuatorPages/ValuatePage';
import IsMonthRoute from './components/Routes/isMonthRoute';

function App() {
    return (
        <>
            <Routes>
                <Route path='/' element={<PrivateRoute><IsMonthRoute><Home/></IsMonthRoute></PrivateRoute>} />
                <Route path='/månedsrapport' element={<IsMonthRoute><Månedsrapport/></IsMonthRoute>} />
                <Route path='/strategi' element={<PrivateRoute><IsMonthRoute><Strategi/></IsMonthRoute></PrivateRoute>} />
                <Route path='/rollefordeling' element={<PrivateRoute><Rollefordeling/></PrivateRoute>} />
                <Route path='/admin-panel' element={<PrivateRoute><AdminRoute><IsMonthRoute><AdminPanel/></IsMonthRoute></AdminRoute></PrivateRoute>} />
                <Route path='/profile' element={<PrivateRoute><IsMonthRoute><Profile/></IsMonthRoute></PrivateRoute>} />
                <Route path='/sign-up' element={<PrivateRoute><SignUp/></PrivateRoute>} />
                <Route path='/sign-in' element={<PublicRoute><SignIn /></PublicRoute>} />
                <Route path='/forgot-password' element={<ForgotPassword />} />
                <Route path="/valuator" element={<IsHrRoute><ValuatorHome/></IsHrRoute>}/>
                <Route path="/valuator/cases" element={<IsHrRoute><CaseListPage /></IsHrRoute>} />
                <Route path="/valuator/archived-cases" element={<IsHrRoute><ArchivedCaseListPage isArchived={true}/></IsHrRoute>} />
                <Route path="/valuator/cases/:caseId" element={<IsHrRoute><CasePage isArchived={false} /></IsHrRoute>} />
                <Route path="/valuator/workers" element={<IsHrRoute><WorkersPage isArchived={false} /></IsHrRoute>} />
                <Route path="/valuator/workers/:workerId" element={<IsHrRoute><WorkerDetailsPage /></IsHrRoute>} />
                <Route path="/valuator/archived-cases/:caseId" element={<IsHrRoute><CasePage isArchived={true} /></IsHrRoute>} />
                <Route path="/valuator/valuate/:caseId" element={<IsHrRoute><ValuatePage /></IsHrRoute>} />
                <Route path="/valuator/admin-panel" element={<IsHrRoute><AdminRoute><ValuatorAdminPanel /></AdminRoute></IsHrRoute>} />
                <Route path="/access-denied" element={<AccessDeniedPage />} />
            </Routes>
            <ToastContainer />
        </>
    );
}

export default App;
